import type { PurchaseBonus } from "@/lib/api";

/**
 * The one-time "your points are waiting" notice after signup. Kept in
 * sessionStorage so it survives the redirect that follows verification, and
 * announced by event so an already-mounted notice picks it up at once.
 */

const KEY = "aistyle:welcome-bonus";
export const WELCOME_BONUS_EVENT = "aistyle:welcome-bonus";

export function announceWelcomeBonus(bonus: PurchaseBonus): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(bonus));
  } catch {
    /* storage blocked — the event below still shows it on this page */
  }
  window.dispatchEvent(new CustomEvent<PurchaseBonus>(WELCOME_BONUS_EVENT, { detail: bonus }));
}

/** Reads the pending notice and clears it, so it is shown only once. */
export function takeWelcomeBonus(): PurchaseBonus | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return raw ? (JSON.parse(raw) as PurchaseBonus) : null;
  } catch {
    return null;
  }
}
